import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { processText } from '@aytm/app/stats/page/components/lib/utils'
import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

// components
import ImagePreview from '@aytm/app/stats/components/image-preview/ImagePreview'
// import ImagePreview from '@aytm/app/survey/editor/components/content/assets/ImagePreview'
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

// styles
import style from '@aytm/app/stats/page/question-views/ir/styles/Block.module.scss'

const Block = ({ id, answer, link, image, instruction, ir_choice_type, isSurveyGuest, isReportXpert }) => (
  <BlockWrapper {...{ id, link, answer, isSurveyGuest, isReportXpert }}>
    {ir_choice_type == 0 ? (
      <div className={style.instructions} dangerouslySetInnerHTML={{ __html: processText(instruction) }} />
    ) : ir_choice_type == 1 ? (
      <div className={style.image}>
        {undefined != image && undefined != image.original ? (
          <ImagePreview
            className={style['image-box']}
            minWidth="50px"
            maxWidth="600px"
            minHeight="50px"
            maxHeight="600px"
            imageUrl={image.original.url}
            previewUrl={getImageAssetPath({
              path: image.original.path,
              width: 600,
              height: 600,
              filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT,
              backgroundColor: 'white'
            })}
            allowScrolling={image.scrolling}
          />
        ) : null}
      </div>
    ) : null}
  </BlockWrapper>
)

Block.displayName = 'Block'

Block.propTypes = {
  id: PropTypes.string,
  answer: answerPropType,
  link: PropTypes.string,
  image: PropTypes.object,
  instruction: PropTypes.string,
  ir_choice_type: PropTypes.number,
  isReportXpert: PropTypes.bool,
  isSurveyGuest: PropTypes.bool
}

export default Block
